import { debounce, TextField, withStyles } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useCallback, useEffect, useState } from "react";

export const MultiSelectDropdown = ({ getItems, handleChange, placeholder, styles, selectedItems, isMultiple = false, isClicked = false, ...rest }
    : { getItems, handleChange, placeholder?, styles?, selectedItems?, isMultiple?, isClicked?}) => {

    const [items, setItems] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [searchQuery, setSearchQuery] = useState<string>();
    const getFilteredItems = useCallback(
        debounce(async (searchText, callback) => {
            // dont fire API if the user delete or not entered anything
            if (searchText !== "" || searchText !== null) {
                setIsLoading(true);
                const response = await getItems(searchText);
                callback(response);
            }
        }, 300), []);

    const uniqueId = "tags-outlined-" + Math.floor(Math.random() * 100) + 1;

    useEffect(() => {
        getFilteredItems(searchQuery, (filtered) => {
            const response = selectedItems && selectedItems.length ?
                filtered.filter(i => !selectedItems.map(e => e.id).includes(i.id)) : filtered;
            setItems(response);
            setIsLoading(false);
        });
    }, [searchQuery, getFilteredItems]);

    const ariaLabel: string = rest['aria-label'];

    return (
        <StyledAutocomplete
            multiple={isMultiple}
            id={uniqueId}
            size="small"
            value={selectedItems}
            style={styles}
            loading={isLoading}
            options={items}
            getOptionLabel={(option: any) => option.name || option.value}
            filterSelectedOptions
            onClick={(event) => event.stopPropagation()}
            onFocus={(event) => event.preventDefault()}
            onInputChange={(_, searchQuery) => setSearchQuery(searchQuery)}
            onChange={(_, item: any) => {
                handleChange(item);
            }}
            renderInput={(params) => (
                <TextField
                    label={ariaLabel}
                    {...params}
                    variant="outlined"
                    placeholder={placeholder}
                    className={selectedItems ? "" : "error"} />
            )}
        />
    );
};

const StyledAutocomplete = withStyles({
    root: {
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#e3e9ed'
        },
        "& .MuiFormControl-root": {
            "& .MuiAutocomplete-inputRoot": {
                padding: "2px 6px"
            }
        },
        marginTop: 4,
        marginBottom: 4
    },
    inputRoot: {
        minHeight: 32,
        borderRadius: 2
    }
})(Autocomplete);
